<template>
	<div class="mobile-tabs-wrapper">
		<div
			v-for="(item, index) in options"
			:key="index"
			@click="changeTabs(item)"
			class="mobile-tabs-item"
			:class="{
				'mobile-tabs-item--active': getSyncKeyValue(item) === activeTabId
			}"
		>
			<span>{{ item[labelKey] }}</span>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	options: {
		type: Array,
		default: () => []
	},
	labelKey: {
		type: String,
		default: 'name'
	},
	syncKey: {
		type: String,
		default: ''
	},
	active: {
		type: [String, Number]
	}
});
const emits = defineEmits(['update:active']);

const activeTabId = computed({
	get() {
		return props.active;
	},
	set(val) {
		emits('update:active', val);
	}
});
const getSyncKeyValue = item => (props.syncKey ? item[props.syncKey] : item[props.labelKey]);
const changeTabs = item => {
	activeTabId.value = getSyncKeyValue(item);
};
</script>

<style lang="less" scoped>
.mobile-tabs-wrapper {
	padding-top: 8px;
	padding-bottom: 16px;
	display: flex;
	align-items: center;
	flex-wrap: nowrap;

	overflow-x: auto;
	scroll-behavior: smooth;
	&::-webkit-scrollbar {
		display: none;
	}

	.mobile-tabs-item {
		margin-left: 24px;

		&:first-child {
			margin-left: 16px;
		}
		&:last-child {
			margin-right: 16px;
		}

		span {
			color: #4e5969;
			 
			font-size: 14px;
			 
			font-weight: 400;
			line-height: 18px; /* 128.571% */
			white-space: nowrap;
		}
		&--active {
			position: relative;

			&::after {
				content: '';
				position: absolute;
				bottom: -8px;
				left: 0;
				right: 0;
				margin: auto;
				width: 12px;
				height: 2px;
				border-radius: 8px;
				background: #1d2129;
				pointer-events: none;
			}

			span {
				color: #1d2129;
				font-size: 16px;
				 
				font-weight: 500;
				line-height: 24px; /* 150% */
			}
		}
	}
}
</style>
